module.exports = __webpack_public_path__ + "static/media/  (60).e4bafb39.jpg";